import * as React from 'react'
import { useEffect } from 'react'
import { Alert, Card } from 'reactstrap'
import connect from './connect'
import TwoFactorEnabledView from './TwoFactorEnabledView'
import TwoFactorInitiateView from './TwoFactorInitiateView'
import TwoFactorVerifyView from './TwoFactorVerifyView'
import TwoFactorBackupCodesView from './TwoFactorBackupCodesView'

interface TwoFactorSetupProps {
  otpRequiredForLogin: boolean
  canDisable?: boolean

  // Props from Redux state
  twoFactorEnabled: boolean
  loading: boolean
  otpSecret: string
  qrCodeUrl: string
  error: string
  success: string
  backupCodes: string[]

  // Action creators
  initTwoFactorEnabled: (isEnabled: boolean) => void
  initiate2FASetup: () => void
  verify2FASetup: (otpCode: string) => void
  disable2FA: () => void
}

function TwoFactorSetup(props: TwoFactorSetupProps) {
  const {
    otpRequiredForLogin,
    canDisable = true,

    twoFactorEnabled,
    loading,
    otpSecret,
    qrCodeUrl,
    error,
    success,
    backupCodes,

    initTwoFactorEnabled,
    initiate2FASetup,
    verify2FASetup,
    disable2FA,
  } = props

  const effectiveOtpSecret = otpSecret

  useEffect(() => {
    initTwoFactorEnabled(otpRequiredForLogin)
  }, [])

  return (
    <Card className="two-factor-setup-card">
      {(error || success) && (
        <div className="col mt-3">
          {error && <Alert color="danger">{error}</Alert>}
          {success && <Alert color="success">{success}</Alert>}
        </div>
      )}
      {backupCodes && backupCodes.length > 0 && <TwoFactorBackupCodesView backupCodes={backupCodes} />}
      {twoFactorEnabled && <TwoFactorEnabledView loading={loading} disable2FA={disable2FA} canDisable={canDisable} />}
      {!twoFactorEnabled && effectiveOtpSecret && (
        <TwoFactorVerifyView
          loading={loading}
          qrCodeUrl={qrCodeUrl}
          otpSecret={effectiveOtpSecret}
          onVerify={verify2FASetup}
        />
      )}
      {!twoFactorEnabled && !effectiveOtpSecret && (
        <TwoFactorInitiateView loading={loading} onInitiate={initiate2FASetup} />
      )}
    </Card>
  )
}

export default connect(TwoFactorSetup)
